import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import EntryHero from './components/EntryHero';
import HotRanking from './components/HotRanking';
import UpdateFeed from './components/UpdateFeed';
import EventTimeline from './components/EventTimeline';
import AngleCompare from './components/AngleCompare';
import TopicCloud from './components/TopicCloud';
import SubscribeBar from './components/SubscribeBar';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <EntryHero />
        <HotRanking />
        <UpdateFeed />
        <EventTimeline />
        <AngleCompare />
        <TopicCloud />
        <SubscribeBar />
      </main>
      <SiteFooter />
    </div>
  );
}